import { render } from "./userProfile.vue?vue&type=template&id=01a09843&scoped=true"
import script from "./userProfile.vue?vue&type=script&lang=js"
export * from "./userProfile.vue?vue&type=script&lang=js"

import "./userProfile.vue?vue&type=style&index=0&id=01a09843&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a09843"]])

export default __exports__